module.exports = __webpack_public_path__ + "img/receipt-icon-white.75c89ee9.svg";